import * as React from 'react';

import style from './process.less';

export interface WProcessStepConfig {
    name: string;
    component: JSX.Element;
}

interface WProcessStepProps extends React.ClassAttributes<any> {
    name: string;
    component: JSX.Element;
}

interface WProcessStepState {
    stepIndex: number;
}

export class WProcessStep extends React.Component<WProcessStepProps, WProcessStepState> {

    constructor(props: any) {
        super(props);
        this.state = {
            stepIndex: 0
        };
    }

    render() {
        return (
            <div className={style.colContainer}>
                <div className={style.flexItem}>
                    <b>{this.props.name}</b>
                </div>
                <div className={style.flexItem}>
                    {this.props.component}
                </div>
            </div>
        );
    }
}
